"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnifiedSearch;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _searchContext = require("./hooks/search-context");
var _unifiedSearchInternal = _interopRequireDefault(require("./unified-search-internal"));
/* eslint-disable max-statements */

function UnifiedSearch({
  searchStringMinLength = _patternLibraryUtils.SEARCH_MIN_LENGTH,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_searchContext.InternalSearchProvider, (0, _extends2.default)({}, props, {
    searchStringMinLength: searchStringMinLength
  }), /*#__PURE__*/_react.default.createElement(_unifiedSearchInternal.default, props));
}
UnifiedSearch.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  autocompleteEndpoint: _propTypes.default.string.isRequired,
  fuzzy: _propTypes.default.bool,
  resultsEndpoint: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string.isRequired,
  searchAriaLabel: _propTypes.default.string,
  domainSearchEndpoint: _propTypes.default.string.isRequired,
  searchBanner: _propTypes.default.object,
  searchSerp: _propTypes.default.object,
  clearAriaLabel: _propTypes.default.string,
  popularListLabel: _propTypes.default.string.isRequired,
  suggestionsListLabel: _propTypes.default.string.isRequired,
  resultsListLabel: _propTypes.default.string.isRequired,
  noResultsListLabel: _propTypes.default.string.isRequired,
  resultsExternalPaths: _propTypes.default.string.isRequired,
  suggestedSearchesHeadline: _propTypes.default.string.isRequired,
  source: _propTypes.default.string,
  helpSource: _propTypes.default.string,
  aiPoweredTagText: _propTypes.default.string,
  searchStringMinLength: _propTypes.default.number
};
UnifiedSearch.defaultProps = {
  fuzzy: true,
  source: 'es',
  helpSource: 'api'
};